import { Get, Post, Delete } from "./apiHelper";
import { Client } from "../interfaces/ClientInterface";

export interface FingerprintTemplatesType {
  id: number;
  clientId: number;
  resourceCentreId?: number;
  template: string;
}

export const WS_URL = "ws://localhost:5241/ws/fingerprint";
export const WS_RECONNECT_DELAY_MS = 3000;

const fingerprintApiUrl = "/api/fingerprints";
const AGENT = "http://localhost:5241/api/fingerprint"; // C# local agent

export async function getFingerprintTemplates(): Promise<FingerprintTemplatesType[]> {
  const response = await Get(`${fingerprintApiUrl}`);
  return response.data as FingerprintTemplatesType[];
}

export async function getFingerprintTemplateById(
  fId: number
): Promise<FingerprintTemplatesType & { client: Client }> {
  const response = await Get(`${fingerprintApiUrl}/${fId}`);
  return response.data as FingerprintTemplatesType & { client: Client };
}

export async function deleteFingerprintTemplateById(fId: number): Promise<{ message: string }> {
  const response = await Delete(`${fingerprintApiUrl}/${fId}`);
  return response.data as { message: string };
}

export async function postFingerprintTemplate({
  templateBase64,
  clientId
}: {
  templateBase64: string;
  clientId: number;
}): Promise<FingerprintTemplatesType> {
  const response = await Post(`${fingerprintApiUrl}`, { templateBase64, clientId }, true);
  return response.data as FingerprintTemplatesType;
}

export const agentPost = async (path: string, body?: object): Promise<any> => {
  const res = await fetch(`${AGENT}${path}`, {
    method: "POST",
    headers: body ? { "Content-Type": "application/json" } : {},
    body: body ? JSON.stringify(body) : undefined
  });
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    throw new Error(j.message ?? `Agent error ${res.status}`);
  }
  return res.json();
};

export const agentDelete = async (path: string): Promise<any> => {
  const res = await fetch(`${AGENT}${path}`, { method: "DELETE" });
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    throw new Error(j.message ?? `Agent error ${res.status}`);
  }
  return res.json();
};
